import { Subscription } from '@/types/models.types';

/**
 * Checks if the user has an active subscription to a specific product by an author.
 *
 * @param authorId - The ID of the author.
 * @param subscriptions - Array of user's subscriptions.
 * @returns true if the user has an active subscription, false otherwise.
 */
export const hasUserSubscribed = (authorId: string, subscriptions: Subscription[]): boolean => {
  const result = subscriptions.some((sub) => {
    const isMatch = sub?.author?.lookupKey.toString() === authorId && sub.active;
    return isMatch;
  });

  return result;
};
